import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, Autocomplete, Select, Box, MenuItem, InputLabel, FormControl, useTheme
} from '@mui/material';
import { tokens } from "../../../theme/theme";

const NewProductSubGroupDialog = ({
    open, onClose, onAdd, onClear, newProductSubGroup = {}, handleInputChange, label,
    valueDDL, onChange, options, getOptionLabel, error, helperText
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    position: 'absolute',
                    top: 0,
                    margin: '0px', // Adjust as needed
                },
            }}
        >
            <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                New Product Sub Group
            </DialogTitle>
            <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                {/* <Autocomplete
                    sx={{ marginTop: '5px' }}
                    fullWidth
                    size="small"
                    value={valueDDL}
                    onChange={onChange}
                    options={options}
                    getOptionLabel={getOptionLabel}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            error={Boolean(error)}
                            helperText={helperText}
                            label={label}
                        />
                    )}
                /> */}

<Autocomplete
                    sx={{ marginTop: '5px' }}
                    fullWidth
                    size="small"
                    value={valueDDL}
                    onChange={onChange}
                    options={options}
                    getOptionLabel={getOptionLabel}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            // error={Boolean(error)}  // Display error if `error` is true
                            // helperText={helperText} // Display helper text if provided
                            error={!newProductSubGroup.PGroupId}
                            helperText={!newProductSubGroup.PGroupId && "Product Group Code is required"}
                            label={label}
                            required  // Make the field required
                        />
                    )}
                />

                <TextField
                    autoFocus
                    margin="dense"
                    name="PSubGroupCode"
                    size='small'
                    label="Product Sub Group Code"
                    fullWidth
                    value={newProductSubGroup.PSubGroupCode || ''}
                    onChange={handleInputChange}
                    required
                    error={!newProductSubGroup.PSubGroupCode}
                    helperText={!newProductSubGroup.PSubGroupCode && "Product Sub Group Code is required"}
                />
                
                <TextField
                    margin="dense"
                    name="PSubGroupDesc"
                    size='small'
                    label="Sub Group Description"
                    fullWidth
                    value={newProductSubGroup.PSubGroupDesc || ''}
                    onChange={handleInputChange}
                    required
                    error={!newProductSubGroup.PSubGroupDesc}
                    helperText={!newProductSubGroup.PSubGroupDesc && "Sub Group Description is required"}
                />
                <FormControl fullWidth margin="dense" size='small'>
                    <InputLabel>Status</InputLabel>
                    <Select
                        name="PSubGroupStatus"
                        value={newProductSubGroup.PSubGroupStatus || ''}
                        onChange={handleInputChange}
                    >
                        {/* <MenuItem value=""><em>None</em></MenuItem> */}
                        <MenuItem value="A">Active</MenuItem>
                        <MenuItem value="IA">Inactive</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                <Box justifyContent={'space-between'} >
                    <Button
                        variant='contained'
                        style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', backgroundColor: '#1769aa' }}
                        onClick={onAdd}
                    >
                        Save
                    </Button>
                    <Button
                        variant='contained'
                        onClick={onClear}
                        style={{ marginRight: '10px', fontSize: '12px', backgroundColor: '#c5c7c6', color: 'black', textTransform: 'none' }}
                    >
                        Clear
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default NewProductSubGroupDialog;
